<template>
  <div class="transition">
    <BasicText size="h5">Veuillez sélectionner la nature de frais</BasicText>
    <div class="transition-items">
      <BasicCheckbox
        v-for="item in props.in"
        :key="item.nature"
        :label="item.intitule"
        :model-value="estRadionOn(item)"
        @update:model-value="updateOut(item)"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
  import type { CarteEvents, CarteProps } from '@/features/interface/machine-etats/types.ts'
  import type { NatureFraisAnnexeModele } from '@/features/interface/demande/af/steps/frais/types.ts'

  type In = NatureFraisAnnexeModele[]
  type Out = NatureFraisAnnexeModele

  const props = defineProps<CarteProps<In, Out>>()
  const emits = defineEmits<CarteEvents<Out>>()

  const estRadionOn = (nf: NatureFraisAnnexeModele) => {
    return props.out?.nature === nf.nature
  }

  const updateOut = (nf: NatureFraisAnnexeModele) => {
    emits('outChanged', true, nf)
  }
</script>
<style lang="less" scoped>
  @import '@/features/interface/demande/ajouter/cartes/ChoixCarte.less';
</style>
